import { TourPerfilModel } from "./tour-perfil.model";
import { createReducer ,on } from "@ngrx/store";
import { resetTourPerfil, setTourPerfil } from "./tour-perfil.actions";

const initialState: TourPerfilModel = {
  tourPerfil: false
}; // este es el estado inicial de tourPerfil

export const tourPerfilReducer = createReducer(
  initialState,
  on(setTourPerfil, (state, { tourPerfil }) => ({ ...state, tourPerfil })),
  on(resetTourPerfil, (state) => ({ ...state, tourPerfil: false }))
);
